.cardGrid {
  display: grid;
  gap: var(--grid-mobile-gap);
  row-gap: var(--grid-row-gap, var(--grid-mobile-gap));
  grid-template-columns: repeat(var(--grid-mobile-cols, 2), minmax(0, 1fr));
  grid-auto-flow: row dense;
  width: 100%;

  @media (--reefer-media-tablet-min) {
    gap: var(--grid-gap);
    row-gap: var(--grid-row-gap, var(--grid-gap));
    grid-template-columns: repeat(
      auto-fill,
      minmax(var(--grid-min-card-width), 1fr)
    );
  }
}

.cardGrid_listView {
  grid-template-columns: 1fr;
  width: 100%;
}

.cardGrid_autoFillMobile {
  grid-template-columns: repeat(
    auto-fill,
    minmax(var(--grid-min-card-width), 1fr)
  );
}

.placement {
  position: relative;
  grid-column: 1 / -1;
  grid-row: 3;
  border-radius: var(--border-radius-lg);
  border: 1px inset var(--colors-transparent-black-five);
  overflow: hidden;
  padding: 24px;

  @media (--reefer-media-tablet-min) {
    padding: 40px;
  }
}

.placement::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    111deg,
    color-mix(
        in srgb,
        var(--placement-gradient-color) 10%,
        var(--colors-grays-white)
      )
      0%,
    color-mix(
        in srgb,
        var(--placement-gradient-color) 5%,
        var(--colors-grays-white)
      )
      100%
  );
}

.placement_background {
  position: absolute;
  inset: 0;
  clip-path: polygon(0 0, 100% 0, 100% 40%, 0 80%);
  background: linear-gradient(
    111deg,
    color-mix(
        in srgb,
        var(--placement-gradient-color) 12%,
        var(--colors-grays-white)
      )
      0%,
    color-mix(
        in srgb,
        var(--placement-gradient-color) 8%,
        var(--colors-grays-white)
      )
      100%
  );
}

.placement_content {
  position: relative;
}
